import { Box, Typography } from '@mui/material'
import React, { useState } from 'react'
import ModalHeader from '../../common/Header'
import DropDown from '../../common/DropDown'
import MButton from '../../common/MButton'
import PeopleIcon from '@mui/icons-material/People';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import { useDispatch } from 'react-redux'
import { updateShowAlert } from '../../../redux/Actions'

const SelectPickups = (props) => {
    const { setCurrentScreen, filterOpt, filterValue, setFilterValue, handleBack } = props
    const dispatch = useDispatch()
    const handleGenerate = () => {
        if (filterValue?.pickupGrp?.length === 0) {
            dispatch(updateShowAlert({
                msg: 'Select Pickup Group!',
                open: true,
            }));
            return
        }
        if (filterValue?.pickup?.length === 0) {
            dispatch(updateShowAlert({
                msg: 'Select Pickup!',
                open: true,
            }));
            return
        }
        setCurrentScreen(3)
    }
    return (
        <Box>
            <ModalHeader headerText={"Select Pickups"} showBackArrow={true} onBackClick={handleBack} />
            <Box className='filter-section-pickups'>
                <Box className='filterRow'>
                    <Box className='filterLabel'>
                        <Typography>Pickup<br />Group</Typography>
                    </Box>
                    <Box className='dropDownFilter'>
                        <DropDown label='Pickup Group'
                            showTopLable={false}
                            headerLabel='Select Pickup Group'
                            StartIcon={true}
                            Icon={PeopleIcon}
                            option={[{ GroupName: "All Pickup Group" }, ...filterOpt?.pickupGrp] || []}
                            // option={filterOpt?.pickupGrp}
                            primaryKey='GroupName'
                            labelKey='GroupName'
                            preSelectedValues={filterValue?.pickupGrp || []}
                            onSelect={(val) => {
                                setFilterValue((prev) => ({
                                    ...prev,
                                    pickupGrp: val
                                }))
                            }}
                        />
                    </Box>
                </Box>
                <Box className='filterRow'>
                    <Box className='filterLabel'>
                        <Typography>Pickup</Typography>
                    </Box>
                    <Box className='dropDownFilter'>
                        <DropDown label='Pickup'
                            showTopLable={false}
                            headerLabel='Select Pickup'
                            StartIcon={true}
                            Icon={DirectionsBusIcon}
                            option={[{ PickupId: 0, PickupName: "All Pickups" }, ...filterOpt?.pickup] || []}
                            //option={filterOpt?.pickup}
                            primaryKey='PickupId'
                            labelKey='PickupName'
                            preSelectedValues={filterValue?.pickup || []}
                            onSelect={(val) => {
                                setFilterValue((prev) => ({
                                    ...prev,
                                    pickup: val
                                }))
                            }}
                        />
                    </Box>
                </Box>
                <MButton btnName="Generate Report" onClick={handleGenerate} />
            </Box>

        </Box>
    )
}

export default SelectPickups